// extracted by mini-css-extract-plugin
module.exports = {"card-body-venues":"Venues_card-body-venues__uh_RF","venue-card-button":"Venues_venue-card-button__3QU27"};